import aws4 from 'aws4'
import querystring from 'querystring'
import url from 'url'

export default {
  patchAxios(client){
    // add aws signed request headers to every request
    client.interceptors.request.use(config => {
      const query = {}
      let queryStr = ''

      Object
      .keys(config.params || {})
      .filter(k => config.params[k] !== undefined)
      .sort()
      .forEach(k => {
        query[k] = config.params[k]
      })

      if(Object.keys(query).length > 0) queryStr = '?' + querystring.stringify(query)

      let _url = url.parse(config.baseURL + config.url + queryStr)
      if(config.url.match(/^http/)) _url = url.parse(config.url + queryStr)

      const request = {
        service: 'execute-api',
        region: process.env.AWS_REGION || 'eu-central-1',
        host: _url.host,
        url: config.url,
        path: _url.path,
        method: config.method.toUpperCase(),
        headers: {
          'Accept': 'application/json'
        }
      }

      if(config.data){
        try{
          request.body = JSON.stringify(config.data)
        }catch(e){
          console.log('JSON:', config.data)
          console.log('ERROR', e)
        }

        request.headers['Content-Type'] = 'application/json'
      }

      const signed = aws4.sign(request, {
        secretAccessKey: AWS.config.credentials.secretAccessKey,
        accessKeyId: AWS.config.credentials.accessKeyId,
        sessionToken: AWS.config.credentials.sessionToken
      })

      delete signed.headers['Host']
      delete signed.headers['Content-Length']

      return Object.assign({}, config, signed)
    })
  }
}



// WEBPACK FOOTER //
// ./shared/aws.js